import React, { useState } from 'react'

import clsx from 'clsx'

import Divider from 'components/Divider'
import Drawer from 'components/Drawer'
import Facets from 'components/Filters/components/Facets'
import Header from 'components/Filters/components/Header'
import StickyFilterToggle from 'components/Filters/components/StickyFilterToggle'
import { useEventContext } from 'context/EventContext'
import detachTask from 'helpers/detachTask'
import { getSelectedFilters } from 'helpers/filters'

import classes from './Filters.module.scss'

/** @type {import("./types").default} */
const Filters = ({
  facets,
  rootUrl,
  title = 'Filter results',
  variant = 'temporary',
  clearCallback = () => {},
  spa = false,
  ...moreProps
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const { sendEvent } = useEventContext()

  const toggleDrawer = event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    const newDrawerIsOpen = !isDrawerOpen
    detachTask(setIsDrawerOpen, newDrawerIsOpen)
  }

  return (
    <div className={clsx('Filters', classes.root)}>
      <Drawer
        isSeoFriendly
        anchor="right"
        data-testid="filters"
        onClose={e => {
          detachTask(toggleDrawer, e)
          detachTask(sendEvent, {
            engagementDestination: 'go-to_show_filters',
            engagementComponent: 'filter',
            engagementDetails: 'filters_right_hide',
            name: 'engagement_filter',
          })
        }}
        open={isDrawerOpen}
        variant={variant}
        {...moreProps}
      >
        <Header facets={facets} clearCallback={clearCallback} rootUrl={rootUrl} title={title} disableSPA={!spa} />
        <Divider />
        <Facets facets={facets} disableSPA={!spa} />
      </Drawer>
      <StickyFilterToggle
        label={'Filter list '}
        selectedFilters={getSelectedFilters(facets)}
        onClick={e => {
          detachTask(toggleDrawer, e)
          detachTask(sendEvent, {
            engagementDestination: 'go-to_show_filters',
            engagementComponent: 'filter',
            engagementDetails: 'filters_right_show',
            name: 'engagement_filter',
          })
        }}
      />
    </div>
  )
}

export default Filters
